import { string } from 'yup'

export const validatePassword = string()
  .required('Password is required')
  .matches(
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{10,}$/,
    'A password with a minimum of 10 characters containing 1 capital letter, 1 lower case letter, and 1 number is required.'
  )
  .max(255, 'Password must be 255 characters or less')
